import { render } from "./GoodTableTotalProducts.vue?vue&type=template&id=2b7f6023"
import script from "./GoodTableTotalProducts.vue?vue&type=script&lang=js"
export * from "./GoodTableTotalProducts.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fahrezibayuprabowo/Documents/project/accessories-cellular-frontend-dev-muped/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__